module.exports = __webpack_public_path__ + "static/media/macarons.7328a157.jpg";